import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import { red } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/Favorite";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import { useDispatch } from "react-redux";
import { updateData } from "../../store/actions/receipeActions";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 200,
    margin: "10px",
    borderRadius: 20,
    padding: 20,
    boxShadow: "0 0 20px 0px rgba(20,20,0,.01)",
  },
  media: {
    height: 0,
    paddingTop: "56.25%",
    borderRadius: 20,
    width: "100%", // 16:9
  },
  heading: {
    fontSize: "1.1rem",
    fontWeight: "600",
    margin: "0 20px",
  },
  avatar: {
    backgroundColor: red[500],
  },
  gridCard: {
    margin: "auto",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const RecipeCard = ({ id, login, receipes }) => {
  const { image, likes: like, title, approved } = receipes;
  const classes = useStyles();
  const [liked, setLiked] = useState(false);
  const history = useHistory();
  const [likes, setLikes] = useState(like);
  const dispatch = useDispatch();
  const updateLikes = () => {
    if (login) {
      dispatch(
        updateData(id, {
          likes: liked ? likes - 1 : likes + 1,
          approved: true,
        })
      );
      setLikes(liked ? likes - 1 : likes + 1);
      setLiked(!liked);
    } else {
      history.push("/login");
      alert("Please login to like the reciepe !!!!");
    }
  };
  return (
    approved && (
      <Grid className={classes.gridCard} item xs={24} md={3} xl={3}>
        <Card className={classes.root}>
          <CardMedia
            className={classes.media}
            image={image}
            title="Paella dish"
            onClick={() => history.push(`/receipe/${id}`)}
          />

          <CardActions className={classes.actions} disableSpacing>
            <IconButton onClick={updateLikes} aria-label="add to favorites">
              <FavoriteIcon color={liked ? "secondary" : "none"} />
            </IconButton>
            <Chip
              onClick={updateLikes}
              clickable
              color="primary"
              label={`${likes} ${likes > 1 ? "Likes" : "Like"}`}
            />
          </CardActions>
          <h6
            onClick={() => history.push(`/receipe/${id}`)}
            className={classes.heading}
          >
            {title}
          </h6>
        </Card>
      </Grid>
    )
  );
};
export default RecipeCard;
